import React from 'react';
import { observer } from 'mobx-react';
import myLeadsState from 'Stores/myLeads';
import { Utils } from 'Utils/utils';
import { userDetail } from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import { purchaseStatusPopupState } from 'Components/common/purchaseStatusPopup';
import ContactPhone from 'Components/common/ContactList/ContactPhone';
import ContactEmailScore from 'Components/common/ContactList/contactEmailScore';
import { ReactComponent as ContactEmailIcon } from 'Assets/svg/contact-email.svg';
import { ReactComponent as CopyIcon } from 'Assets/svg/copy.svg';

const tabNames = CONSTANTS.MY_LEADS_TABS;

const ContactEmailPhone = observer(props => {
  const {
    contactId,
    email,
    score,
    phoneNumberFromVendor = null,
    isDownloaded = false,
    allUpdatedFlag = false,
    currentTab = null,
    status = '',
    purchaseContactFunc = null,
    isNewEmailAvailable = false,
  } = props;

  const { featureFlags } = userDetail;
  const { COPY_RESTRICTION = false, PHONE_NUMBER = false } = featureFlags;
  const copyContactInfo = (e, id, isDownload, type, newValue = false) => {
    const str = e.currentTarget.getAttribute('data-value');
    e.preventDefault();
    if (isDownload || COPY_RESTRICTION === false) {
      Utils.copyToClipBoard(str);
      Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_COPY_CLICKED, {
        type,
        currentTab: tabNames[currentTab],
        new: newValue,
      });
      purchaseStatusPopupState.setToastMsg(null, null, null, true);
    }
  };

  const purchaseContactIfNotOwned = e => {
    if (e) e.preventDefault();
    if (!isDownloaded && purchaseContactFunc !== null)
      purchaseContactFunc(e, contactId);
  };

  const isContactWithoutEmail =
    status === 'ACTIVE_WITHOUT_EMAIL' ||
    status === 'ACTIVE_WITHOUT_EMAIL_PHONE';

  const isEmailAndPhoneNotAvailable =
    isContactWithoutEmail &&
    (!phoneNumberFromVendor || phoneNumberFromVendor.length === 0);

  return (
    <div
      className={`contact-info${isEmailAndPhoneNotAvailable ? ' no-data' : ''}`}
    >
      {isEmailAndPhoneNotAvailable ? (
        <span>
          <i>- Not Available -</i>
        </span>
      ) : (
        <>
          {email !== null &&
            email !== undefined &&
            email !== '' &&
            !isContactWithoutEmail && (
              <div className="contact-email">
                <div className="info-icon">
                  <ContactEmailIcon />
                </div>
                <div className="contact-email-copy-wrap">
                  <div className="email-wrapper">
                    <div
                      className={`info-detail show-elipsis ${
                        isDownloaded ? 'default-cursor' : ''
                      }`}
                      onClick={e => purchaseContactIfNotOwned(e)}
                    >
                      {email}
                    </div>
                    {isDownloaded && (
                      <CopyIcon
                        className="copy-icon"
                        onClick={e =>
                          copyContactInfo(
                            e,
                            contactId,
                            isDownloaded,
                            'email',
                            isNewEmailAvailable,
                          )
                        }
                        data-value={email}
                      />
                    )}
                    <ContactEmailScore
                      score={score}
                      email={email}
                      status={status}
                      currentPage="myLeads"
                    />
                    {isNewEmailAvailable && [2, 3].includes(currentTab) && (
                      <span className="updates-container">
                        <button
                          type="button"
                          className="btn new-btn"
                          aria-label="NEW"
                        />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          {phoneNumberFromVendor !== null && (
            <ContactPhone
              phone={phoneNumberFromVendor}
              contactId={contactId}
              pageName="myleads"
            />
          )}
        </>
      )}
    </div>
  );
});

export { ContactEmailPhone };
export default ContactEmailPhone;
